export const APPLICATION_KEY_OVERRIDES = {
  ssn: 'SSN',
  ssnEncrypted: 'SSNEncrypted',
  achAccountNumber: 'ACHAccountNumber',
}
